const SPEEDS: any = [
    {
        code: '0.25',
        title: 'Chậm',
    },
    {
        code: '0.8',
        title: 'Vừa',
    },
    {
        code: '1.2',
        title: 'Nhanh',
    }
];

export default SPEEDS;


// WEBPACK FOOTER //
// ./src/constants/SPEEDS.ts